// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getServiceAreas } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetServiceAreaApi = createAsyncThunk("hitGetServiceAreaApi", async (token=null) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("professionalToken")? localStorage.getItem("professionalToken") : token}`,
      },
    };
    const url = ApiBaseUrl + getServiceAreas;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    toast.error(error.response.data.message);
    throw error.response.data;
  }
});

const GetServiceAreaSlice = createSlice({
  name: "getServiceAreaProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetServiceAreaData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetServiceAreaApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetServiceAreaApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetServiceAreaApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetServiceAreaData } = GetServiceAreaSlice.actions;
export default GetServiceAreaSlice.reducer;